import { motion, useScroll, useSpring } from "framer-motion";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import FeatureSection from "@/components/landing/FeatureSection";
import EcosystemSection from "@/components/landing/EcosystemSection";
import ProblemsSolutions from "@/components/landing/ProblemsSolutions";
import TechStack from "@/components/landing/TechStack";
import Tokenomics from "@/components/landing/Tokenomics";
import StakingSection from "@/components/landing/StakingSection";
import NodeValidator from "@/components/landing/NodeValidator";
import LotterySection from "@/components/landing/LotterySection";
import Roadmap from "@/components/landing/Roadmap";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import { PILLARS } from "@/data/content";

export default function Landing() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  return (
    <div className="relative grain bg-[var(--trt-black)] text-[var(--text)]">
      {/* Scroll progress */}
      <motion.div
        style={{ scaleX }}
        className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[60] bg-gradient-to-r from-[var(--gold-1)] via-[var(--gold-2)] to-[var(--gold-4)]"
      />

      <Navbar />
      <main>
        <Hero />
        {PILLARS.map((p, i) => (
          <FeatureSection key={p.id} data={p} index={i} />
        ))}
        <EcosystemSection />
        <ProblemsSolutions />
        <TechStack />
        <Tokenomics />
        <StakingSection />
        <NodeValidator />
        <LotterySection />
        <Roadmap />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
